export default "__VITE_ASSET__DFj$Z3Ii__"